var objectKeys = function(obj) {
  return Object.keys(obj);
};
function objectEntries(obj) {
  return Object.entries(obj);
}
function objectFromEntries(arr) {
  return Object.fromEntries(arr);
}
export {
  objectEntries,
  objectFromEntries,
  objectKeys
};
//# sourceMappingURL=helpers.js.map
